<template>
  <c-row>
    <c-col col="12">
      <loader v-show="loading" />
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Mutasi Bank</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div>
            <div class="form-group">
              <select-x
                :url="`/api/v1/bank-account`"
                :label="`name`"
                v-model="filter.bank_account"
                @input="changeBankAccount"
                :placeholder="`Pilih bank akun`"
              />
            </div>
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Tanggal</th>
                  <th>Penjelasan Transaksi</th>
                  <th>Keterangan</th>
                  <th>Bank</th>
                  <th>Debit</th>
                  <th>Kredit</th>
                  <th>Saldo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(d, k) in bankHistory.data" :key="k">
                  <td>{{ d.created_at | dateFormat }}</td>
                  <td>{{ d.description }}</td>
                  <td>{{ d.notes }}</td>
                  <td>{{ d.bank_name }}</td>
                  <td class="right">{{ d.debit | thousandSeparator }}</td>
                  <td class="right">{{ d.credit | thousandSeparator }}</td>
                  <td class="right">{{ d.balance | thousandSeparator }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <div class="form-group float-left">
            <button class="btn btn-success" @click="exportExcel">
              Export Excel
            </button>
          </div>
          <paginator :paginator="bankHistory.paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import Paginator from '../../components/Paginator.vue';
import { HTTPAUTH, HTTPExport } from "../../lib/httplib";
import SelectX from '../../components/SelectX.vue';
import Loader from '../../components/Loader.vue';
export default {
  components: {
    Paginator,
    SelectX,
    Loader
  },
  data () {
    return {
      bankHistory: {},
      filter: {
        bank_account: null
      },
      loading: false,
    };
  },
  computed: {
    bankAkunId () {
      return this.$route.query.ba;
    }
  },
  created () {
    this.history(1, this.bankAkunId);
  },
  methods: {
    changePage (page) {
      this.history(page, this.bankAkunId)
    },
    history (page, bank_account_id) {
      this.loading = true
      let bank = '';
      if (bank_account_id) {
        bank = `b=${bank_account_id}`
      }
      HTTPAUTH.get(`/api/v1/bank-history?size=10&page=${page}&${bank}`)
        .then(res => {
          this.bankHistory = res.data;
          this.$router.push({ query: { page: res.data.paginate.page, ba: bank_account_id } }).catch(() => { })
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        });
    },
    exportExcel () {
      this.loading = true
      HTTPExport.get("/api/v1/export/excel/bank-history").then((res) => {
        const data = res.data.data;
        window.open(data, '_blank');
        this.loading = false;
      }).catch(() => {
        this.loading = false
      });
    },
    changeBankAccount (ba) {
      if (ba) {
        this.history(1, ba.id)
      } else {
        this.history(1)
      }
    }
  }
};
</script>